<div class="wrap">
  <ng-container *ngIf="!isCreationMode && !isFileMode && !isSessionMode">
    <div class="header">
      <div class="title">
        <fa-icon [icon]="getFaIcon('faChevronLeft')" (click)="goBack()" appChangeColorTheme attribute="color">
        </fa-icon>
        <h2>{{club?.clubName}}</h2>
      </div>
      <div class="update_club">
        <fa-icon [icon]="getFaIcon('faEdit')" [matTooltip]="getTooltip('clubDetailUpdate')"
          (click)="openDialogUpdateClub('update')" appChangeColorTheme attribute="color">
        </fa-icon>
      </div>
    </div>

    <div class="infos_club">

      <ng-container *ngIf="!isLoadingClubDetails">
        <app-contact-address [club]="club"></app-contact-address>
      </ng-container>
      <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="75"></mat-spinner>

      <div class="practice_place_priority_offer">
        <ng-container *ngIf="!isLoadingClubDetails">
          <app-practice-place [userConnected]="userConnected"></app-practice-place>
          <div class="tags-url" [formGroup]="tagForm">
            <div class="tags">
              <mat-form-field appearance="outline">
                <mat-label>Tags</mat-label>
                <mat-select formControlName="tags" multiple>
                  <mat-optgroup *ngFor="let type of tagTypes" [label]="type.tagTypeName">
                    <mat-option *ngFor="let tag of type.tags" [value]="tag">{{ tag.tagName }}</mat-option>
                  </mat-optgroup>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Centre d'intérêt</mat-label>
                <mat-select formControlName="universe">
                  <mat-option *ngFor="let universe of universes" [value]="universe">
                    {{ universe.universeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <button mat-icon-button matTooltip="Réinitailiser les champs" matTooltipPosition="above" [disabled]="tagForm.get('tags')?.invalid || tagForm.get('universe')?.invalid" (click)="resetFields()">
                <mat-icon>autorenew</mat-icon>
              </button>

              <button mat-icon-button matTooltip="Générer une url" matTooltipPosition="above" [disabled]="tagForm.get('tags')?.invalid || tagForm.get('universe')?.invalid" (click)="generateUrl()">
                <mat-icon>send</mat-icon>
              </button>
            </div>
            <div class="url">
              <mat-form-field appearance="outline">
                <mat-label>Url</mat-label>
                <input matInput type="text" formControlName="url">
              </mat-form-field>

              <button mat-icon-button matTooltip="Copier l'url" matTooltipPosition="above" [disabled]="tagForm.get('url')?.invalid" (click)="copyUrl()">
                <mat-icon>content_copy</mat-icon>
              </button>

              <button mat-icon-button matTooltip="Ouvrir le lien" matTooltipPosition="above" [disabled]="tagForm.invalid" (click)="openNewPage()">
                <mat-icon>open_in_browser</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
        <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="75"></mat-spinner>
      </div>

    </div>


    <div class="offers" *ngIf="!isLoading">

      <div class="header_offer">

        <div class="tabs">
          <div [ngClass]="{tab_active: tab ==='offers', tab: tab !== 'offers'}" (click)="selectTab('offers')">
            <!-- Vitrine (offres) -->
             <span>Liste des articles</span>
          </div>

          <!-- <div [ngClass]="{tab_active: tab ==='closedBooking', tab: tab !== 'closedBooking'}"
            (click)="selectTab('closedBooking')">
            Paniers en cours
          </div> -->

        </div>

        <div class="add_search_offer">
          <div class="add_offer" (click)="addOffer()" *ngIf="!isLoadingClubDetails && tab === 'offers'"
            appChangeColorTheme attribute="color">
            <fa-icon [icon]="getFaIcon('faPlus')"></fa-icon>
            <!-- <span>Ajouter une offre</span> -->
            <span>Ajouter un article</span>
          </div>
          <mat-spinner *ngIf="isLoadingClubDetails" [diameter]="25"></mat-spinner>
          <div class="search_bar">
            <form [formGroup]="searchForm">
              <input type="text" [placeholder]="getPlaceholderInputSearch()" (input)="applyFilter($event.target.value)"
                formControlName="keyword">
            </form>

            <fa-icon [icon]="valueInput ? getFaIcon('faTimes') : getFaIcon('faSearch')"
              (click)="valueInput? resetSearch(): null"></fa-icon>
          </div>
        </div>

      </div>

      <ng-container [ngSwitch]="tab">

        <div class="offers_club" *ngSwitchCase="'offers'">
          <app-table-offers-club *ngIf="tab ==='offers'" [offers]="offers" [clubCode]="clubCode"
            [valueSearch]="valueInput" [club]="club" (offerPreviewUpdate)="changeOfferPreview($event)"
            (onEdit)="onEdit($event)" (imageUpdate)="imageUpdate=$event" (switchToSession)="switchToSessionView($event)"
            (switchToFiles)="switchToFilesView($event)" (refreshOffers)="getClub()">
          </app-table-offers-club>
          <app-admin-preview-offer [offerPreview]="offerPreview" [imageUpdate]="imageUpdate"></app-admin-preview-offer>
        </div>

        <app-table-offer-inprogress *ngSwitchCase="['closedBooking' ,'basket'].includes(tab)? tab : '' "
          [valueSearch]="valuefilterSelected" [tab]="tab"></app-table-offer-inprogress>
      </ng-container>

    </div>

    <mat-spinner *ngIf="isLoading" [diameter]="50" style="margin: 0 auto;"></mat-spinner>
  </ng-container>

  <div *ngIf="isCreationMode || isSessionMode || isFileMode" class="content" [style.grid-template-columns]="'1fr 35%'">
    <ng-container *ngIf="isCreationMode">
      <app-admin-offer-edit [offer]="offerToEdit ?? null" (editFinished)="onEditFinished($event)"
        (offerPreviewUpdate)="changeOfferPreview($event)" (imageUpdate)="imageUpdate=$event"
        (switchToSession)="switchToSessionView($event)"></app-admin-offer-edit>
    </ng-container>

    <ng-container *ngIf="isSessionMode">
      <app-admin-offer-session [offer]="offerToEdit" (editFinished)="onEditFinished($event)"></app-admin-offer-session>
    </ng-container>

    <ng-container *ngIf="isFileMode">
      <app-admin-offer-file [offerKey]="offerToEdit.offerKey"
        (editFinished)="onEditFinished($event)"></app-admin-offer-file>
    </ng-container>

    <app-admin-preview-offer [offerPreview]="offerPreview" [imageUpdate]="imageUpdate"></app-admin-preview-offer>
  </div>
</div>
